import React from "react";
import Hero from "../Components/Hero";
import Expertise from "../Components/Expertise";
import Contact from "../Components/Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <Expertise />
      <Contact />
    </>
  );
};

export default Home;
